import {
  fetchFlexiFund,
  fetchTextPay,
  fetchQuickSwap,
  fetchShareGain,
} from "@/api/walletService";

export default {
  //Fetch flexiFund
  async fetchFlexiFund({ commit, dispatch }) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      const response = await fetchFlexiFund();
      commit("SET_FLEXIFUND_DATA", response.data);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your wallets loaded.",
          color: "primary",
        },
        { root: true }
      );
      //Fetch transactions
      dispatch("transactions/fetchTransactionsBehind", null, { root: true });
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Fetch textPay
  async fetchTextPay({ commit, dispatch }) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      const response = await fetchTextPay();
      commit("SET_TEXTPAY_DATA", response.data);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your wallets loaded.",
          color: "primary",
        },
        { root: true }
      );
      //Fetch transactions
      dispatch("transactions/fetchTransactionsBehind", null, { root: true });
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Fetch quickPay
  async fetchQuickSwap({ commit, dispatch }) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      const response = await fetchQuickSwap();
      commit("SET_QUICKSWAP_DATA", response.data);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your wallets loaded.",
          color: "primary",
        },
        { root: true }
      );
      //Fetch transactions
      dispatch("transactions/fetchTransactionsBehind", null, { root: true });
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Fetch shareGain
  async fetchShareGain({ commit, dispatch }) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      const response = await fetchShareGain();
      commit("SET_SHAREGAIN_DATA", response.data);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your wallets loaded.",
          color: "primary",
        },
        { root: true }
      );
      //Fetch transactions
      dispatch("transactions/fetchTransactionsBehind", null, { root: true });
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Transaction not allowed!
  async transactionNotAllowed({ commit }) {
    // eslint-disable-next-line no-useless-catch
    commit(
      "SHOW_SNACKBAR",
      {
        text: "Transaction combination not allowed.",
        color: "error",
      },
      { root: true }
    );
  },
};
